// extracted by mini-css-extract-plugin
export default {"pcWrap":"houseLike_pcWrap__l7AEo"};